import {useEffect} from 'react';

import {InteractionStatus} from '@azure/msal-browser/dist/utils/BrowserConstants';
import {UnauthenticatedTemplate, useIsAuthenticated, useMsal} from '@azure/msal-react';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';

import LoginForm from './LoginForm';
import Spinner from '../../components/spinner/Spinner';
import {APP_ROUTES} from '../../const';
import useAuth from '../../hooks/providers/useAuth';
import useProfile from '../../hooks/providers/useProfile';

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  overflow-y: hidden;
`;

// eslint-disable-next-line complexity
const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const context = useMsal();
  const {isConsentsLoading} = useProfile();
  const isLogged = useIsAuthenticated();

  useEffect(() => {
    (async () => {
      if (isLogged) {
        navigate(APP_ROUTES.connections, {replace: true});
      }
    })();
  }, [isLogged]);

  const isLoginRunning = document.cookie.length > 0 && document.cookie.includes('msal');

  return (
    <Container>
      {!isLoginRunning && (
        <>
          {!isLogged && [InteractionStatus.Login, InteractionStatus.None].includes(context.inProgress) && (
            <UnauthenticatedTemplate>
              <LoginForm />
            </UnauthenticatedTemplate>
          )}

          {(context.inProgress === InteractionStatus.HandleRedirect || isLogged) && !isConsentsLoading && <Spinner size={128} withoutText isLoading />}
        </>
      )}
    </Container>
  );
};

export default Login;
